export default "__VITE_ASSET__CuABdH0u__"